module.exports = __webpack_public_path__ + "img/抱歉.ef2e4b2b.jpg";